import {
    ACTIVITIES,
    COMPANIES,
    INTERNET_EMAIL,
    MARKETING_CAMPAIGN_ACTIVITY,
    OPPORTUNITIES,
    PHONE_CALL_LOGS,
} from 'constants/Entities';
import { MARKETING_CAMPAIGN_EXPORT_SCHEMA_ID } from './marketingCampaignActivity';

export const ACTIVITY_EXPORT_SCHEMA_PHONE_CALL = 'phonecall';
export const ACTIVITY_EXPORT_SCHEMA_CHECKIN = 'checkin';
export const ACTIVITY_EXPORT_SCHEMA_VIDEO_CALL_CHECKIN = 'videocallcheckin';
export const ACTIVITY_EXPORT_SCHEMA_FAST_CHECKIN = 'fastcheckin';
export const ACTIVITY_EXPORT_SCHEMA_OPPORTUNITY_CHECKIN = 'opportunitycheckin';
export const ACTIVITY_EXPORT_SCHEMA_INTERNET_EMAIL = 'internetemail';
export const ACTIVITY_EXPORT_SCHEMA_ACTIVITY = 'activity';
export const ACTIVITY_EXPORT_SCHEMA_VIDEO_CALL = 'videocall';
export const ACTIVITY_EXPORT_SCHEMA_WHATSAPP = 'whatsapp';

export { MARKETING_CAMPAIGN_EXPORT_SCHEMA_ID };

/** Maps Activities filter field ids to export schema ids. */
export const ACTIVITY_EXPORT_FILTER_TO_SCHEMA_ID = {
    callType: ACTIVITY_EXPORT_SCHEMA_PHONE_CALL,
    listCheckInType: ACTIVITY_EXPORT_SCHEMA_CHECKIN,
    videoCallCheckInType: ACTIVITY_EXPORT_SCHEMA_VIDEO_CALL_CHECKIN,
    fastCheckIn: ACTIVITY_EXPORT_SCHEMA_FAST_CHECKIN,
    opportunityCheckIn: ACTIVITY_EXPORT_SCHEMA_OPPORTUNITY_CHECKIN,
    email: ACTIVITY_EXPORT_SCHEMA_INTERNET_EMAIL,
    type: ACTIVITY_EXPORT_SCHEMA_ACTIVITY,
    videoCallType: ACTIVITY_EXPORT_SCHEMA_VIDEO_CALL,
    whatsappType: ACTIVITY_EXPORT_SCHEMA_WHATSAPP,
};

export const ACTIVITY_EXPORT_SCHEMA_TO_FILTER_ID = Object.entries(
    ACTIVITY_EXPORT_FILTER_TO_SCHEMA_ID,
).reduce((obj, [filterId, schemaId]) => {
    obj[schemaId] = filterId;
    return obj;
}, {});

export const ACTIVITY_EXPORT_ICONS_BY_SCHEMA_ID = {
    [ACTIVITY_EXPORT_SCHEMA_PHONE_CALL]: 'call',
    [ACTIVITY_EXPORT_SCHEMA_CHECKIN]: 'accountCheckin',
    [ACTIVITY_EXPORT_SCHEMA_VIDEO_CALL_CHECKIN]: 'videoCheckin',
    [ACTIVITY_EXPORT_SCHEMA_FAST_CHECKIN]: 'fastCheckin',
    [ACTIVITY_EXPORT_SCHEMA_OPPORTUNITY_CHECKIN]: 'opportunityCheckin',
    [ACTIVITY_EXPORT_SCHEMA_INTERNET_EMAIL]: 'email',
    [ACTIVITY_EXPORT_SCHEMA_ACTIVITY]: 'activities',
    [ACTIVITY_EXPORT_SCHEMA_VIDEO_CALL]: 'videoCamera',
    [ACTIVITY_EXPORT_SCHEMA_WHATSAPP]: 'whatsappGreen',
    [MARKETING_CAMPAIGN_EXPORT_SCHEMA_ID]: 'marketingCampaign',
    [COMPANIES.trueName]: 'accounts',
    [OPPORTUNITIES.trueName]: 'opportunities',
};

/** Maps export schema ids to `useActivitiesConfig` state keys (entity trueName). */
const ACTIVITY_EXPORT_SCHEMA_TO_CONFIG_KEY = {
    [ACTIVITY_EXPORT_SCHEMA_INTERNET_EMAIL]: INTERNET_EMAIL.trueName,
    [ACTIVITY_EXPORT_SCHEMA_PHONE_CALL]: PHONE_CALL_LOGS.trueName,
    [MARKETING_CAMPAIGN_EXPORT_SCHEMA_ID]: MARKETING_CAMPAIGN_ACTIVITY.trueName,
};

export const getActivityExportEntityConfig = (config, schemaId) =>
    config[ACTIVITY_EXPORT_SCHEMA_TO_CONFIG_KEY[schemaId]] ?? config[ACTIVITIES.trueName];
